"use strict";
exports.__esModule = true;
function uqnJoin(array) {
    var n = array.length - 1, num = 0;
    array.forEach(function (e) {
        num += Number(e) * Math.pow(10, n);
        n--;
    });
    return num;
}
exports["default"] = uqnJoin;
